class JsPdf{

	constructor(){
		this.csv = false;
	}

	setCSV(){
		this.csv = true;
	}

	removerTooltip(el){

		var temp = el.cloneNode(true);

		/* REMOVE TOOLTIPO*/
		var e = temp.querySelectorAll('.boss-tooltip');
		var ell = e.length;

		if(ell > 0){
			for(var xx = 0; xx < ell; xx++){
				Boss.remover(e[xx]);
			}
		}

		/* IGNORA .no-print */
		var e = temp.querySelectorAll('.no-print');
		var ell = e.length;

		if(ell > 0){
			for(var xx = 0; xx < ell; xx++){
				Boss.remover(e[xx]);
			}
		}

		return temp;
	}

	getFromtable(id){
		if(Boss.getById(id)){

			this.pdf = {};
			this.pdf[0] = {};

			this.orientacao = 'L';

			var table = Boss.getById(id);
			this.title = table.getAttribute('data-title');
			this.id = table.getAttribute('id');
			var thead = table.querySelector('thead');
			var th = thead.querySelectorAll('th');
			var lth = th.length;

			if(table.getAttribute('data-orientacao')){
				this.orientacao = table.getAttribute('data-orientacao');
			}

			var totalLargura = 0;

			for(var t = 0; t < lth; t++){

				if(th[t].getAttribute('data-ignore') === null){

					var largura = Number(th[t].getAttribute('data-largura'));
					totalLargura = totalLargura + largura;

					var alinhamentoLinhas = 'C';
					if(th[t].getAttribute('data-alinhamentoLinhas')){
						alinhamentoLinhas = th[t].getAttribute('data-alinhamentoLinhas');
					}

					this.pdf[0][t] = {
						'largura': largura,
						'txt': th[t].textContent,
						'alinhamentoTitulo': 'C',
						'alinhamentoLinhas': alinhamentoLinhas,
						'corTextoTitulo': [0,0,0],
						'corTextoLinhas': [0,0,0]
					};
				}
			}

			var tbody = table.querySelector('tbody');
			var tr = tbody.querySelectorAll('tr');
			var ltr = tr.length;

			for(var x = 0; x < ltr; x++){

				this.pdf[(x + 1)] = {};

				var td = tr[x].querySelectorAll('td');
				var ltd = td.length;

				for(var y = 0; y < ltd; y++){

					if(td[y].getAttribute('data-ignore') === null){

						var onlytext = this.removerTooltip(td[y]);

						var opts = [0,0,0];
						if(td[y].getAttribute('data-opt') !== null){
							opts = td[y].getAttribute('data-opt').split(',');
						}

						this.pdf[(x + 1)][y] = {
							'txt': onlytext.innerText,
							'opt': opts
						};
					}
				}
			}

			this.pdf['totalLargura'] = totalLargura;
		}

		var frm = document.createElement('form');
		frm.setAttribute('accept-charset', 'UTF-8');

		var inpt = document.createElement('input');
		inpt.setAttribute('type', 'hidden');
		inpt.setAttribute('tabindex', '-1');
		inpt.setAttribute('name', 'dados');
		inpt.value = window.btoa(JSON.stringify(this.pdf));

		var title = document.createElement('input');
		title.setAttribute('type', 'hidden');
		title.setAttribute('tabindex', '-1');
		title.setAttribute('name', 'title');
		title.value = this.title;

		var orientacao = document.createElement('input');
		orientacao.setAttribute('type', 'hidden');
		orientacao.setAttribute('tabindex', '-1');
		orientacao.setAttribute('name', 'orientacao');
		orientacao.value = this.orientacao;

		frm.appendChild(inpt);
		frm.appendChild(title);
		frm.appendChild(orientacao);
		frm.setAttribute('method', 'post');
		frm.setAttribute('target', 'jspdf');

		if(Boss.getById('div-jspdf')){
			Boss.remover(Boss.getById('div-jspdf'));
		}

		var csv = '';
		if(this.csv === true){
			csv = '&d=csv';
			frm.setAttribute('target', 'iframe-csv');
		}

		frm.setAttribute('action', '/jspdf?rel='+this.id+csv);

		if(this.csv === true){
			frm.setAttribute('target', 'iframe-csv');
		}

		var dv = document.createElement('div');
		dv.setAttribute('id', 'div-jspdf');
		dv.appendChild(frm);
		dv.classList.add('hidden');

		if(this.csv === true){

			var frame = document.createElement('iframe');
			frame.setAttribute('id', 'iframe-csv');
			frame.setAttribute('name', 'iframe-csv');
			dv.appendChild(frame);

		}

		Boss.getById('content').appendChild(dv);
		frm.submit();

	}
};